
import { defineComponent, computed, toRefs } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    orderUrl: { type: String, required: false, default: undefined },
    streamUrl: { type: String, required: false, default: undefined },
    saleIsAvailable: { type: Boolean, required: false, default: undefined },
    concertState: { type: Object, required: false, default: undefined },
  },
  setup(props, { emit }) {
    const { concertState } = toRefs(props)

    const mapConcertStateToLabel = {
      SOLD_OUT: 'event-detail-sold-out-button-label',
      EXPIRED: 'event-detail-expired-button-label',
      MOVED: 'event-detail-moved-button-label',
      CANCELED: 'event-detail-canceled-button-label',
    }

    function setDisabledButtonLabel(concertState) {
      if (concertState.EXPIRED) {
        return 'event-detail-expired-button-label'
      }

      if (concertState.SOLD_OUT) {
        return 'event-detail-sold-out-button-label'
      }

      return mapConcertStateToLabel[Object.keys(concertState).find((key) => concertState[key])]
    }

    return {
      orderClick: () => emit('orderClick'),
      showDisabledButton: computed(() => Object.values(concertState.value).some((value) => value)),
      disabledButtonLabel: computed(() => setDisabledButtonLabel(concertState.value)),
    }
  },
})
